interface Props {
  className?: string;
}

export const Close = ({ className }: Props) => {
  return (
    <svg viewBox="-1 -1 24 24" height="24" width="24" fill="none" className={className}>
      <path
        d="m0.6875 21.31158333333333 20.625 -20.625"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      ></path>
      <path
        d="M21.3125 21.31158333333333 0.6875 0.6865833333333333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      ></path>
    </svg>
  );
};
